import { TEMPLATE_URL } from './constants.js';

export const downloadTemplate = async () => {
  try {
    const response = await fetch(TEMPLATE_URL);
    if (!response.ok) {
      throw new Error(`Failed to download template: ${response.statusText}`);
    }
    
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  } catch (error) {
    console.error('Error downloading template:', error);
    throw error;
  }
};